<template>
    <footer>
        <div class="container">
            <div class="footerBottom">
                <p class="copyrights">
                    ©{{ currentYear }} Autopay.pl All rights reserved.
                </p>
                <p class="footerInfo">
                    <span class="contactPhones">
                        <span>{{ $t('footer.contact')}} tel.: <a href="tel:587604844"><span class="bold"><span v-if="!isPolishLang()">+48</span> 58 760 48 44</span></a> - {{ $t('footer.individualCustomer')}},&nbsp;</span>
                        <span><a href="tel:585008005"><span class="bold"><span v-if="!isPolishLang()">+48</span> 58 500 80 05</span></a> - {{ $t('footer.companyCustomer')}}</span>
                    </span>
                </p>
            </div>
            <div class="footerBottomVersionPrint">
                <p>
                    Dokumentacja biblioteki mobilnej Autopay SDK wersja 3.2
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import { defaultLang } from '../../i18n'

export default {
  name: 'LayoutFooter',
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    }
  },
  methods: {
    isPolishLang () {
      return this.$i18n.locale === defaultLang
    }
  }
}
</script>
